import { fonts, rootUrl } from '../registry.json.js';

var fontStack = function fontStack(fonts) {
  return fonts.map(function (font) {
    return font.includes(' ') ? "\"".concat(font, "\"") : font;
  }).join(', ');
};
function printFontFace(name, weight, style, file) {
  var fontFormats = Object.keys(fonts[name][file]);
  var srcUrls = fontFormats.map(function (format) {
    var url = "".concat(rootUrl).concat(fonts[name][file][format].fullPath);
    return "url(\"".concat(url, "\") format(\"").concat(format, "\")");
  });
  return "\n    @font-face {\n      font-family: ".concat(name, ";\n      src: ").concat(srcUrls.join(','), ";\n      font-weight: ").concat(weight, ";\n      font-style: ").concat(style, ";\n    }\n  ");
}

export { fontStack, printFontFace };
//# sourceMappingURL=utils.js.map
